module.exports = __webpack_public_path__ + "media/images/places-2-play-logo-f967fbcc.png";